module.exports = __webpack_public_path__ + "media/images/subject_img/PHYSICS-THEORETICAL PHYSICS-60a6ad41c1a6d59b02e2730c0fcc1ad9.jpg";